import type { EventContentObjectList } from 'models';
import { useMutation } from 'query';
import { deleteEvent } from '../../services';
import { getContentObjectId } from '../../utils';
import { useContentObjectCache } from '../cache';

type DeleteEventContentObject = { contentObject: EventContentObjectList };

export const useDeleteEventContentObjectMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<DeleteEventContentObject, DeleteEventContentObject>({
    async mutationFn(object) {
      await deleteEvent({ routeParams: { id: getContentObjectId(object.contentObject) } });

      return object;
    },
    onSuccess(_data, { contentObject }) {
      cache.remove(contentObject);
    },
  });
};
